/* eslint-disable react/prop-types */
import ImgNotAvailable from '@/../img/placeholders/city-placeholder.jpg';
import { fallbackTexts } from '@/constants';
import { PropertyPlatforms } from '@/widgets/components/property-platforms';
import { VerifiedIcon } from '@/widgets/components/verified-icon';
import styled from 'styled-components';
import { PropertyDotAndType } from '../property-dot-and-type';
import * as Popup from './map-popup-styles';

// Revert to background-image if coverImage fails
const FallbackWrapper = styled.div`
  height: 100%;
  width: 100%;

  img {
    position: relative;
  }

  img:before {
    content: ' ';
    display: block;
    position: absolute;
    height: 100%;
    border-radius: 4px;
    transform: scale(1.05);
    width: 172px;
    background: round;
    background-color: white;
    background-image: url(${ImgNotAvailable});
  }
`;

// function IconComponent({ icon: Icon, sizer: Sizer }) {
//   return (
//     <Sizer>
//       <Icon />
//     </Sizer>
//   );
// }

// function RoomComponent({ bedrooms, bathrooms }) {
//   return (
//     <Popup.RoomValue>
//       <Popup.RoomCount>{bedrooms}</Popup.RoomCount>
//       <IconComponent icon={BedIcon} sizer={Popup.RoomIconSizer} />
//       <Popup.RoomCount ml="10px">{bathrooms}</Popup.RoomCount>
//       <IconComponent icon={BathIcon} sizer={Popup.RoomIconSizer} />
//     </Popup.RoomValue>
//   );
// }

const VerifiedPropertyIcon = styled(VerifiedIcon)`
  display: flex;
  flex-shrink: 0;
  font-size: 16px;

  svg {
    margin: auto;
  }
`;

const Flex = styled.div`
  display: flex;
  gap: 5px;
`;

const PropertyAddress = styled.p`
  font-weight: bold;
`;

const Div = styled(Flex)`
  flex-direction: column;
  margin: 20px 20px 10px;
`;

const StyledPropertyPlatforms = styled(PropertyPlatforms)`
  position: absolute;
  background-color: rgba(255, 255, 255, 0.85);
`;

export function MapPopup({ propertyData, platformIcons }) {
  const { violations } = propertyData; // Bug: "violations" is a JSON string rather than an array

  const hasViolations = Array.isArray(violations) && violations.length > 0;

  /**
   * "displayPopupAndDoManyOtherThings" method of rendering this component
   * results in fields with values of "null" being converted to the string "null"
   */
  const propertyAddress =
    propertyData.address !== 'null'
      ? propertyData.address
      : fallbackTexts.PENDING_IDENTIFICATION;

  return (
    <Popup.Card data-cy="pop-up">
      <Div>
        <Flex>
          <PropertyAddress>{propertyAddress}</PropertyAddress>
          <VerifiedPropertyIcon
            isProperty
            verifiedStatus={propertyData.verifiedStatus}
          />
        </Flex>
        <PropertyDotAndType property={propertyData} marginCSS="0" />
      </Div>

      <Popup.Body>
        <FallbackWrapper>
          {/* No aria-hidden attribute is used, as the listing platforms are overlaid on top of the property image. */}
          <Popup.LazyImg
            alt="Property"
            id={`${propertyData.deckardid}-popup-img`}
            src={ImgNotAvailable}
          />
        </FallbackWrapper>

        {Boolean(propertyData.onlinePlatforms.length) && (
          <StyledPropertyPlatforms
            onlinePlatforms={propertyData.onlinePlatforms}
            platformIcons={platformIcons}
            positions={{ top: '85px', left: '30px' }}
          />
        )}

        {hasViolations && (
          <Popup.Summary>
            <>
              <Popup.Violations>
                <Popup.SummaryItemLabel>
                  Possible Violations
                </Popup.SummaryItemLabel>
              </Popup.Violations>
              {violations.map((violation) => (
                <div key={violation}>{violation}</div>
              ))}
            </>
          </Popup.Summary>
        )}
      </Popup.Body>
    </Popup.Card>
  );
}
